// Display helpers shared by every page. Times are stored UTC but the
// trader reads VNT (UTC+7) — kept here so swapping format is one diff.

export function fmtMoney(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  return `${sign}$${abs.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtPrice(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 5 });
}

export function fmtNum(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return n.toLocaleString("en-US");
}

// VNT (UTC+7) — short form "HH:MM DD/MM" for tables; full form below.
export function fmtTs(iso: string | Date | null | undefined): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return "—";
  const vnt = new Date(d.getTime() + 7 * 3600 * 1000);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(vnt.getUTCHours())}:${pad(vnt.getUTCMinutes())} ${pad(vnt.getUTCDate())}/${pad(vnt.getUTCMonth() + 1)}`;
}

export function fmtTsFull(iso: string | Date | null | undefined): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return "—";
  const vnt = new Date(d.getTime() + 7 * 3600 * 1000);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(vnt.getUTCHours())}:${pad(vnt.getUTCMinutes())}:${pad(vnt.getUTCSeconds())} ${pad(vnt.getUTCDate())}/${pad(vnt.getUTCMonth() + 1)}/${vnt.getUTCFullYear()}`;
}

export function fmtAge(staleSeconds: number): string {
  if (staleSeconds < 60) return `${staleSeconds}s`;
  if (staleSeconds < 3600) return `${Math.floor(staleSeconds / 60)}m`;
  if (staleSeconds < 86400) return `${Math.floor(staleSeconds / 3600)}h`;
  return `${Math.floor(staleSeconds / 86400)}d`;
}
